import { useQuery } from '@tanstack/react-query';
import { databaseApi } from '../api';

export const useDatabaseStats = () => {
  return useQuery({
    queryKey: ['database', 'stats'],
    queryFn: () => databaseApi.getStats(),
    enabled: false, // TODO: Database stats API not ready yet
  });
};

export const useSlowQueries = (limit = 10) => {
  return useQuery({
    queryKey: ['database', 'slow-queries', limit],
    queryFn: () => databaseApi.getSlowQueries(limit),
    enabled: false, // TODO: Database stats API not ready yet
  });
};

export const useIndexUsage = () => {
  return useQuery({
    queryKey: ['database', 'index-usage'],
    queryFn: () => databaseApi.getIndexUsage(),
    enabled: false, // TODO: Database stats API not ready yet
  });
};
